import {updateField} from "vuex-map-fields"
import {getDefaultState} from "./projectResponsible"

export default {
	updateField,
	SET_PROJECT_RESPONSIBLES(state, payload) {
		state.project_responsibles = payload
	},
	SET_PROJECT_RESPONSIBLE(state, payload) {
		state.project_responsible = payload
	},
	SET_VALIDATION_ERRORS(state, payload) {
		for (const key in payload) {
			state.validation_project_responsible[key] = '* '+payload[key][0]
		}
	},
	CLEAR_VALIDATION(state) {
		for (const key in state.validation_project_responsible) {
			state.validation_project_responsible[key] = null
		}
	},
}
